const CHART_HOSTS = ['chart.emtrade.id', 'staging-chart.emtrade.id']

const isChartHost = (hostname = window.location.hostname) =>
  CHART_HOSTS.includes(hostname)

export { CHART_HOSTS, isChartHost }
